export default function AnimatedCounter({ value, className = "", testid }) {
  return (
    <span className={`tabular ${className}`} data-testid={testid}>
      {(Number(value) || 0).toLocaleString("en-US")}
    </span>
  );
}
